export default __webpack_public_path__ + "static/media/alphabroder-logo.89b615a2.svg";